import { render, staticRenderFns } from "./TestEditorStages.vue?vue&type=template&id=30c231f4&scoped=true&"
import script from "./TestEditorStages.vue?vue&type=script&lang=js&"
export * from "./TestEditorStages.vue?vue&type=script&lang=js&"
import style0 from "./TestEditorStages.vue?vue&type=style&index=0&id=30c231f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c231f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperHeader,VStepperStep})
